"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mixin;
var _underscore = _interopRequireDefault(require("./underscore.js"));
var _each = _interopRequireDefault(require("./each.js"));
var _functions = _interopRequireDefault(require("./functions.js"));
var _setup = require("./_setup.js");
var _chainResult = _interopRequireDefault(require("./_chainResult.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Add your own custom functions to the Underscore object.
function mixin(obj) {
  (0, _each.default)((0, _functions.default)(obj), function (name) {
    var func = _underscore.default[name] = obj[name];
    _underscore.default.prototype[name] = function () {
      var args = [this._wrapped];
      _setup.push.apply(args, arguments);
      return (0, _chainResult.default)(this, func.apply(_underscore.default, args));
    };
  });
  return _underscore.default;
}